import React from 'react';
import PropTypes from 'prop-types';

const IconVideo = props => {
  const color = props.color || '#585858';
  return (
    <svg width={23} height={23} {...props}>
      <g fill={color} fillRule="nonzero">
        <path d="M11.5 0A11.5 11.5 0 1023 11.5 11.516 11.516 0 0011.5 0zm0 21.62A10.123 10.123 0 011.38 11.5 10.123 10.123 0 0111.5 1.38 10.123 10.123 0 0121.62 11.5 10.134 10.134 0 0111.5 21.62z" />
        <path d="M15.58 11.871l-6.677 3.71V8.16z" />
      </g>
    </svg>
  );
};

IconVideo.propTypes = {
  color: PropTypes.string,
};

export default IconVideo;
